import { useQueryLetterById } from '@/features/integrations-letters/letter-sender-v2/hooks/query/useQueryLetters';
import { LetterContext } from '@heidi/integrations/letters';
import type { components } from '@heidi/schema/ml-scribe';
import { useContext } from 'react';

type LetterResponse = components['schemas']['LetterResponse'];

export const useLetter = <TData = LetterResponse>(
  select: (data: LetterResponse | undefined) => TData
) => {
  const context = useContext(LetterContext);

  // Looks weird to branch in hook but it's fine
  if (!context) {
    throw new Error('Missing LetterProvider');
  }

  const { data } = useQueryLetterById({ letterId: context.letterId, select });
  return data;
};
